import { Injectable } from '@angular/core';

import { AppcmsService } from 'src/app/services/core/appcms.service';
import { CacheService } from 'src/app/services/core/cache.service';
import { CollectionsService } from 'src/app/services/utils/collections.service';
import { UserService } from 'src/app/services/core/user.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  key: string = 'collection_item';
  
  constructor(
    private AppCMS: AppcmsService,
    private cache: CacheService,
    private collections: CollectionsService,
    private userService: UserService,
  ) {

  }

  getCollections(profileId: number = null, blForceRefresh: boolean = false) {
    return this.collections.getByProfileUid(profileId, blForceRefresh);
  }

  get(type: string) {
    return this.collections.get(type);
  }

  getProfile(profileId: number, blForceRefresh: boolean = false, options: any = {}) {
    return new Promise(async (resolve, reject) => {
      const key: string = 'profile_' + profileId + '_' + JSON.stringify(options),
            fromCache: cacheItem = await this.cache.get(key, 10 * 60);
      
      if(!blForceRefresh && (fromCache && fromCache.data)) {
        let cached = fromCache.data;
        cached.collections = this.collections.parseCollections(cached.collectionData);
        resolve(cached);
      } else {
        this.AppCMS.loadPluginData('pipeline', Object.assign({
          user: this.userService.getUid(),
        }, options), ['profile', profileId])
        .then((profileData: profileData) => {
          
          if(profileData.collectionData && profileData.collectionData.custom) {
            profileData.collectionData.custom = {
              items: (profileData.collectionData.custom as any),
            }
          }

          profileData.collections = this.collections.parseCollections(profileData.collectionData);
          this.cache.set(key, profileData);
          resolve(profileData);
        })
        .catch(reject);
      }
    });
  }

  inCollection(item: any) {
    return this.collections.inCollection(item);
  }

  parseCollections(collections: any) {
    return this.collections.parseCollections(collections);
  }
  
  removeFromCollection(item: any, collection: string) {
    return this.collections.removeFromCollection(item, collection);
  }
  
}
